import request from '@/utils/request'

export function uploadImage(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/upload/uploadFile/uploadImage',
      method: 'post',
      data
      // FormData 由 axios 自动设置 Content-Type 为 multipart/form-data; boundary=...
    }).then(response => {
      const res = response.data
      resolve(res.fileId)
    }).catch(error => {
      reject(error)
    })
  })
}

export function listAreaAppeals(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppeal.listAreaAppeals',
      method: 'get',
      params: {
        ...params,
        page: params.page - 1
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryAreaAppealDetail(appealId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppeal.queryAreaAppealDetail',
      method: 'get',
      params: { appealId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || '获取诉求详情失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function replyAreaAppeal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppeal.replyAreaAppeal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '回复诉求失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function auditCancelAreaAppeal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppeal.auditCancelAreaAppeal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核撤销失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteAreaAppeal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppeal.deleteAreaAppeal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除诉求失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryAreaAppealIndex(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppeal.queryAreaAppealIndex',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || '获取首页统计失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
